/**
 * Marketing copy hardcoded straight from the PM-provided HTML mock (PWUXCC-26085), grouped the
 * same way `lib/analytics/schema.ts` groups its vocabularies — one `as const` object per section
 * instead of strings inlined in JSX.
 */

/** Shown wherever a discount percentage is needed before the live pricing plans have loaded. */
export const DEFAULT_DISCOUNT_PERCENT = 40;

/** Struck-through "before" price shown before the live pricing plans have loaded. */
export const DEFAULT_ORIGINAL_PRICE = "₹499";

export const HEADER_COPY = {
  ctaPrefix: "Get",
  ctaSuffix: "OFF",
} as const;

export const HERO_COPY = {
  titleLine1: "Sare PW Lectures.",
  titleLine2: "Ek subscription mein.",
  tagline: "Har lecture unlocked.",
  taglineAccent: "Kabhi bhi cancel karein.",
  ctaPrefix: "Start Learning at",
  ctaSuffix: "/-",
  seePlans: "Saare plans dekhein",
  ratingScore: "4.6",
  ratingSource: "on Play Store",
  learnerCount: "10 lakh+",
  learnerLabel: "learners on Pi",
} as const;

export const TRUST_BADGES = [
  "100% secure payment",
  "Cancel anytime",
  "No hidden charges",
] as const;

export const PRICING_COPY = {
  offerEndsPrefix: "Offer khatam hone mein",
  headingPrefix: "Aaj",
  headingSuffix: "tak OFF — sabhi plans par",
  subheading:
    "Har plan mein poora Pi — every lecture, every DPP, every note, unlimited AI doubt-solving.",
  footnote:
    "✓ Cancel anytime  ·  ✓ No hidden charges  ·  ✓ Renew or stop whenever you want",
} as const;

export const FINAL_CTA_COPY = {
  notPrefix: "nahi — aaj sirf",
  subheadline: "Sare PW Lectures, ek tap door. Kabhi bhi cancel karein.",
  ctaSuffix: "mein shuru karein",
  trustLine: "100% secure payment  ·  No hidden charges  ·  Cancel anytime",
} as const;

export const TESTIMONIALS_COPY = {
  heading: "10 lakh+ learners can't be wrong",
  /** Placeholder reviews carried over from the PM's mock — swap for verified reviews before ship. */
  items: [
    {
      quote:
        "I cancelled three YouTube playlists after starting Pi. Everything I need for NEET is in one app — and the Ask AI is genuinely useful at 11pm.",
      author: "Aditi, NEET Aspirant, Patna",
    },
    {
      quote:
        "₹299 for unlimited PW lectures is ridiculous value. I use it alongside my batch for revision.",
      author: "Rohan, JEE Aspirant, Jaipur",
    },
    {
      quote:
        "The one-shot revisions saved me before my Class 12 boards. Bought yearly without thinking twice.",
      author: "Priya, Class 12, Lucknow",
    },
  ],
} as const;
